export const SCENE_FADE_TIME = 300;
export const ATTACK_DELAY_TIME = 50;

// Tileset stuff
export const BUSH_INDEX = 428;
export const BOX_INDEX = 427;
export const COIN_INDEX = 192;
export const HEART_CONTAINER_INDEX = 233;

export const NPC_MOVEMENT_RANDOM = 'random';
export const NPC_MOVEMENT_STILL = 'still';

// Enemies
export const ENEMY_AI_TYPE = 'follow';

// Save data
export const SAVE_DATA_KEY = 'pablogg_game_data';
